export const LOGIN_URL_LOCAL = 'http://localhost:8888/login';
export const LOGIN_URL = 'https://spowerfy-backend.onrender.com/login';
